export class PlanetaryShieldInfoDTO {
  constructor() {
    this.planet_id = null;
    this.planetary_shield = null;
    this.block_start_raid = null;
  }
}